import { BlockTitle, Icon, List, ListItem } from "framework7-react";
import "./menu.css";

const withClass = (base, className) =>
  className ? `${base} ${className}` : base;

// <List> only puts children whose displayName contains "f7-list-item" into its <ul>.
export const asMenuItem = (Component) =>
  Object.assign(Component, { displayName: "f7-list-item" });

export const MenuSection = ({ title, after, className, children }) => (
  <section className={withClass("side-menu-section", className)}>
    <BlockTitle className="side-menu-title">
      <span className="side-menu-title-text">{title}</span>
      {after}
    </BlockTitle>
    {children}
  </section>
);

export const MenuList = ({ className, children }) => (
  <List
    inset
    strong
    dividersIos
    className={withClass("side-menu-list", className)}
  >
    {children}
  </List>
);

export const MenuItem = asMenuItem(
  ({ className, title, icon, tone, onClick }) => (
    <ListItem
      link
      className={withClass("side-menu-item", className)}
      title={title}
      onClick={onClick}
    >
      <span slot="media" className={`side-menu-icon side-menu-icon-${tone}`}>
        <Icon ios={icon.ios} md={icon.md} />
      </span>
    </ListItem>
  ),
);
